import React from 'react'
import { Text } from '@chakra-ui/core'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'
import { Button } from './Button'

export interface BackButtonProps {
  title: string
  event?: VoidFunction
  disabled?: boolean
}

export const BackButton: React.FC<BackButtonProps> = ({ title, event, disabled = false }) => {
  const isRtl = useSelector(isRtlSelector)

  return (
    <Button
      type="button"
      variant="ghost"
      isDisabled={disabled}
      onClick={event}
      p={0}
      h="auto"
      minW={0}
      flex={1}
      justifyContent="flex-start"
      color="inherit"
      _hover={{ bg: 'transparent' }}
      startIcon={isRtl ? <ChevronRight size={25} /> : <ChevronLeft size={25} />}
    >
      <Text as="span" fontSize="20px" fontWeight="bold" isTruncated minW={0} title={title}>
        {title}
      </Text>
    </Button>
  )
}
